import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { AlertTriangle, Menu, X, Command as CommandIcon } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { CommandPalette } from "@/components/CommandPalette";
import { QuickActions } from "@/components/QuickActions";
import { PresentationProvider } from "@/contexts/PresentationContext";

export const AppLayout = () => {
  const [openNav, setOpenNav] = useState(false);
  const loc = useLocation();
  const isBoardroom = loc.pathname.startsWith("/app/boardroom");

  return (
    <PresentationProvider>
      <div className="min-h-screen flex">
        {!isBoardroom && <Sidebar mobileOpen={openNav} onClose={() => setOpenNav(false)} />}
        <div className="flex-1 min-w-0 flex flex-col">
          {!isBoardroom && (
            <>
              <div className="lg:hidden flex items-center justify-between px-4 py-3 border-b cad-hairline bg-[#071B2B]">
                <button onClick={() => setOpenNav(true)} data-testid="mobile-nav-toggle" className="text-[#DCE3E8]">
                  <Menu size={22} />
                </button>
                <BrandMark size={64} responsive={false} />
                <button onClick={() => setOpenNav(false)} className={`text-[#DCE3E8] ${openNav ? "" : "invisible"}`}>
                  <X size={22} />
                </button>
              </div>
              <div className="flex items-center gap-3 border-b cad-hairline bg-[#0B3558]/40 px-6 py-2 text-[11px]" data-testid="demo-banner">
                <AlertTriangle size={14} className="text-[#C99A2E]" />
                <div className="font-mono-cad uppercase tracking-[0.22em] text-[#DCE3E8] flex-1">
                  Demonstration Environment — Fictional and Synthetic Data — Not an Official Government Register
                </div>
                <div className="hidden md:inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-[10px] font-mono uppercase tracking-[0.14em] border border-white/10 text-[#B3C2CC]"
                     title="Executive command palette · Cmd/Ctrl + K">
                  <CommandIcon size={10} /> K &nbsp;jump to
                </div>
              </div>
            </>
          )}
          <main className={"flex-1 min-w-0 " + (isBoardroom ? "" : "p-6 lg:p-8")}>
            <Outlet />
          </main>
        </div>
        <CommandPalette />
        {!isBoardroom && <QuickActions />}
      </div>
    </PresentationProvider>
  );
};
